import { LocalizedFinding } from '../diagnoses/localized-finding';

/**
 * A localized finding item in a public search query.
 */
export class LocalizedFindingItem {
  public readonly finding: LocalizedFinding;
  public readonly isHighlighted: boolean;

  constructor({
    finding,
    isHighlighted = false
  }: {
    finding: LocalizedFinding;
    isHighlighted?: boolean;
  }) {
    this.finding = finding;
    this.isHighlighted = isHighlighted;
  }

  copyWith({
    finding = undefined,
    isHighlighted = undefined
  }: {
    finding?: LocalizedFinding;
    isHighlighted?: boolean;
  }) {
    return new LocalizedFindingItem({
      finding: finding ?? this.finding,
      isHighlighted: isHighlighted ?? this.isHighlighted
    });
  }

  toJson(): any {
    return {
      localized_finding: this.finding.toJson(),
      is_highlighted: this.isHighlighted
    };
  }
}
